import { render, staticRenderFns } from "./inupalllist.vue?vue&type=template&id=0b7c8041&scoped=true&"
import script from "./inupalllist.vue?vue&type=script&lang=js&"
export * from "./inupalllist.vue?vue&type=script&lang=js&"
import style0 from "./inupalllist.vue?vue&type=style&index=0&id=0b7c8041&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c8041",
  null
  
)

export default component.exports